import { createContext } from 'react'

export const ProjectIndicesContext = createContext()